/* tslint:disable:member-ordering */
import { Directive, ElementRef, OnInit, Input } from "@angular/core";
import { OAuthService } from "./../../services/o-auth";
import { AngularFireDatabase } from "angularfire2/database";

@Directive({
  selector: "[appPermission]",
})
export class PermissionAttribute implements OnInit {
  @Input() operation: string;
  @Input("appPermission") appPermission: string;

  constructor(
    private el: ElementRef,
    private fireDatabase: AngularFireDatabase,
    private oAuthService: OAuthService
  ) {}

  ngOnInit() {
    if (
      this.oAuthService.getClub().type == 3 &&
      this.oAuthService.getClub().role == 1
    ) {
      this.isShow("block");
    } else {
      this.fireDatabase
        .object(
          "user-permissions/" +
            this.oAuthService.getClub().uid +
            "/" +
            this.oAuthService.getClub().cid +
            "/" +
            this.appPermission
        )
        .subscribe((res) => {
          if (res.$exists()) {
            if (res[this.operation]) {
              this.isShow("block");
            } else this.isShow("none");
          } else {
            this.fireDatabase
              .object(
                "master-permissions/" +
                  this.oAuthService.getClub().type +
                  "/" +
                  this.appPermission
              )
              .subscribe((ress) => {
                if (ress.$exists()) {
                  if (ress[this.operation]) {
                    this.isShow("block");
                  } else this.isShow("none");
                } else {
                  this.isShow("none");
                }
              });
          }
        });
    }
  }

  private isShow(isShow) {
    this.el.nativeElement.style.display = isShow;
  }
}
